import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
// const phoneUtil = require("google-libphonenumber");
import parsePhoneNumber from "libphonenumber-js";
import { isValidPhoneNumber } from "libphonenumber-js";
import $axios from "../../utils/axios";

interface PhoneParams {
  countryCode: string;
  onRes: any;
}
type CountryCode =
  | "AC"
  | "AD"
  | "AE"
  | "AF"
  | "AG"
  | "AI"
  | "AL"
  | "AM"
  | "AO"
  | "AR"
  | "AS"
  | "AT"
  | "AU"
  | "AW"
  | "AX"
  | "AZ"
  | "BA"
  | "BB"
  | "BD"
  | "BE"
  | "BF"
  | "BG"
  | "BH"
  | "BI"
  | "BJ"
  | "BL"
  | "BM"
  | "BN"
  | "BO"
  | "BQ"
  | "BR"
  | "BS"
  | "BT"
  | "BW"
  | "BY"
  | "BZ"
  | "CA"
  | "CC"
  | "CD"
  | "CF"
  | "CG"
  | "CH"
  | "CI"
  | "CK"
  | "CL"
  | "CM"
  | "CN"
  | "CO"
  | "CR"
  | "CU"
  | "CV"
  | "CW"
  | "CX"
  | "CY"
  | "CZ"
  | "DE"
  | "DJ"
  | "DK"
  | "DM"
  | "DO"
  | "DZ"
  | "EC"
  | "EE"
  | "EG"
  | "EH"
  | "ER"
  | "ES"
  | "ET"
  | "FI"
  | "FJ"
  | "FK"
  | "FM"
  | "FO"
  | "FR"
  | "GA"
  | "GB"
  | "GD"
  | "GE"
  | "GF"
  | "GG"
  | "GH"
  | "GI"
  | "GL"
  | "GM"
  | "GN"
  | "GP"
  | "GQ"
  | "GR"
  | "GT"
  | "GU"
  | "GW"
  | "GY"
  | "HK"
  | "HN"
  | "HR"
  | "HT"
  | "HU"
  | "ID"
  | "IE"
  | "IL"
  | "IM"
  | "IN"
  | "IO"
  | "IQ"
  | "IR"
  | "IS"
  | "IT"
  | "JE"
  | "JM"
  | "JO"
  | "JP"
  | "KE"
  | "KG"
  | "KH"
  | "KI"
  | "KM"
  | "KN"
  | "KP"
  | "KR"
  | "KW"
  | "KY"
  | "KZ"
  | "LA"
  | "LB"
  | "LC"
  | "LI"
  | "LK"
  | "LR"
  | "LS"
  | "LT"
  | "LU"
  | "LV"
  | "LY"
  | "MA"
  | "MC"
  | "MD"
  | "ME"
  | "MF"
  | "MG"
  | "MH"
  | "MK"
  | "ML"
  | "MM"
  | "MN"
  | "MO"
  | "MP"
  | "MQ"
  | "MR"
  | "MS"
  | "MT"
  | "MU"
  | "MV"
  | "MW"
  | "MX"
  | "MY"
  | "MZ"
  | "NA"
  | "NC"
  | "NE"
  | "NF"
  | "NG"
  | "NI"
  | "NL"
  | "NO"
  | "NP"
  | "NR"
  | "NU"
  | "NZ"
  | "OM"
  | "PA"
  | "PE"
  | "PF"
  | "PG"
  | "PH"
  | "PK"
  | "PL"
  | "PM"
  | "PR"
  | "PS"
  | "PT"
  | "PW"
  | "PY"
  | "QA"
  | "RE"
  | "RO"
  | "RS"
  | "RU"
  | "RW"
  | "SA"
  | "SB"
  | "SC"
  | "SD"
  | "SE"
  | "SG"
  | "SH"
  | "SI"
  | "SJ"
  | "SK"
  | "SL"
  | "SM"
  | "SN"
  | "SO"
  | "SR"
  | "SS"
  | "ST"
  | "SV"
  | "SX"
  | "SY"
  | "SZ"
  | "TA"
  | "TC"
  | "TD"
  | "TG"
  | "TH"
  | "TJ"
  | "TK"
  | "TL"
  | "TM"
  | "TN"
  | "TO"
  | "TR"
  | "TT"
  | "TV"
  | "TW"
  | "TZ"
  | "UA"
  | "UG"
  | "US"
  | "UY"
  | "UZ"
  | "VA"
  | "VC"
  | "VE"
  | "VG"
  | "VI"
  | "VN"
  | "VU"
  | "WF"
  | "WS"
  | "XK"
  | "YE"
  | "YT"
  | "ZA"
  | "ZM"
  | "ZW";

export const Phone = ({ countryCode, onRes }: PhoneParams) => {
  const { t } = useTranslation();

  const [phone, setPhone] = useState("");
  const [firstType, setFirstType] = useState(false);
  const [cc, setCc] = useState("US");
  const [isValid, setIsValid] = useState(false);

  const initCountries = async () => {
    const resee: any = await $axios.get("auth/generate");

    const i = resee.data.data.findIndex((c: any) => c.id == parseInt(countryCode));
    if (!Number.isNaN(parseInt(countryCode)) && i !== -1) {
      const r: any = resee.data.data.at(i);
      setCc(r.country_code);
    }
    if (Number.isNaN(parseInt(countryCode))) setCc(countryCode);
  };

  useEffect(() => {
    if (phone.length > 0) {
      setFirstType(true);
    }

    const phoneNumber = isValidPhoneNumber(phone, cc as CountryCode) && parsePhoneNumber(phone, cc as CountryCode);
    if (phoneNumber) {
      setIsValid( phoneNumber.country === cc && phoneNumber.isValid() && phoneNumber.getType() !== "TOLL_FREE");
      onRes({
        isValid: phoneNumber.isValid(),
        phone: phoneNumber.formatInternational(),
      });
    } else {
      setIsValid(false);
      onRes({ isValid: false, phone: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone,cc]);

  useEffect(() => {
    initCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  return (
    <>
      <TextField
        fullWidth
        InputProps={{ disableUnderline: true }}
        placeholder={t("Phone")!}
        variant="standard"
        name={"phone"}
        value={phone}
        onChange={(e: any) => setPhone((e.target as HTMLInputElement).value)}
        error={!isValid && firstType}
        helperText={!isValid && firstType ? t("Phone need to be valid") : ""}
      />
    </>
  );
};
